import { TRIAL_ERROR_CODES } from "./contract";
import { apiErrorCode, extractApiError } from "../../lib/apiErrors";

/**
 * A super-admin trial refusal, said in the reader's language — the trial vocabulary's
 * twin of `admin/affiliate/errorText.js`.
 *
 * The wire carries `detail = {code, message}` and `message` is English and unlocalisable,
 * so it is never rendered:
 *
 *   · a code in `TRIAL_ERROR_CODES` -> `<prefix>.error.<CODE>`, a sentence already written;
 *   · a code outside it              -> `<prefix>.error.UNKNOWN`;
 *   · no code at all (a dropped connection, an HTML 500 body, pydantic's 422 array)
 *                                     -> `extractApiError`, which flattens those shapes.
 *
 * `prefix` defaults to `t360.trial` — the only reader today (`TrialTile.jsx`) — but stays
 * an argument so a second surface never has to fork this file.
 *
 * @param {any} e the axios error
 * @param {{t: function, prefix?: string, fallback?: string}} opts
 * @returns {string}
 */
export function trialErrorText(e, { t, prefix = "t360.trial", fallback = "" }) {
  const code = apiErrorCode(e);
  if (code) {
    return t(TRIAL_ERROR_CODES.includes(code) ? `${prefix}.error.${code}` : `${prefix}.error.UNKNOWN`);
  }
  return extractApiError(e, fallback, t);
}

export default trialErrorText;
